import styled from 'styled-components';
import colors from 'constants/colors';

export const LegendContainer = styled.div`
  width: 20%;
  display: flex;
  column-gap: 16px;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 130px;
  box-sizing: border-box;
  margin-top: clamp(10px, 20vw + -240px, 200px);

  .rowLabel {
    width: 110px;
    font-size: 14px;
    font-weight: 600;
    text-align: left;
    white-space: nowrap;
    color: ${colors.white};
  }

  .legends {
    display: flex;
    justify-content: center;
    align-items: center;
    column-gap: 16px;
  }
`;

export const LegendItemContainer = styled.div`
  width: 83px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 8px;

  .iconContainer {
    width: 20px;
    min-width: 20px;
    height: 20px;
    background-color: ${({backgroundColor, borderColor }) => backgroundColor ? backgroundColor : borderColor? colors.black1: colors.white};
    ${({borderColor}) => borderColor ?`border: 2px solid ${borderColor}`: null}; 
  }

  .legendTitle {
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.5px;
    text-align: center;
    white-space: nowrap;
    color: ${colors.silver};
  }
`;
